<template>
    <div class="app flex-row align-items-center">
        <div class="container">
            <b-row class="justify-content-center">
                <b-col md="8">
                    <div class="login-header">
                        <img class="login-logo" src="../../../src/assets/img/codelab-logo.png" alt="Codelab Logo " />
                        <p class="messageWelcome">Welcome, it is nice to see you!</p>
                        <!-- <p>Log in to get going</p> -->
                    </div>

                    <b-card-group class="login-group">
                        <b-card no-body class="p-4 login-box">
                            <b-card-body>
                                <p class="login-headline">Log in to get going:</p>

                                <Feedback
                                    :state="validateRef('loginForm.email')"
                                    invalid="This field is required and must be a valid email"
                                ></Feedback>
                                <b-input-group class="mb-3">
                                    <b-input-group-prepend>
                                        <b-input-group-text>
                                            <i class="icon-user"></i>
                                        </b-input-group-text>
                                    </b-input-group-prepend>
                                    <b-form-input
                                        type="email"
                                        v-model="$v.loginForm.email.$model"
                                        class="form-control"
                                        placeholder="Email"
                                    ></b-form-input>
                                </b-input-group>

                                <Feedback
                                    :state="validateRef('loginForm.password')"
                                    invalid="This field is required"
                                ></Feedback>
                                <b-input-group class="mb-4">
                                    <b-input-group-prepend>
                                        <b-input-group-text>
                                            <i class="icon-lock"></i>
                                        </b-input-group-text>
                                    </b-input-group-prepend>
                                    <b-form-input
                                        type="password"
                                        v-model="$v.loginForm.password.$model"
                                        class="form-control"
                                        placeholder="Hasło"
                                    ></b-form-input>
                                </b-input-group>

                                <Feedback :state="loginError.state" :invalid="loginError.message"></Feedback>
                                <br />
                                <b-row>
                                    <b-col cols="6" class="login-button-box">
                                        <b-button @click="login" variant="primary" class="px-4 login-button"
                                            >Login</b-button
                                        >
                                    </b-col>
                                </b-row>
                                <!-- <div class="forgot-password-box">
                                    <router-link to="/auth/forgot-password">
                                        Do you forgot a password?
                                    </router-link>
                                </div> -->
                            </b-card-body>
                        </b-card>
                        <b-card no-body class="text-white bg-primary py-5 d-md-down-none messageRegister">
                            <b-card-body class="text-center">
                                <div class="messageRegisterBox">
                                    <!-- <h2>Sign up</h2> -->
                                    <p class="messegeRegisterText">Don't have an account?</p>
                                    <b-button
                                        @click="$router.push('/auth/register')"
                                        variant="primary"
                                        class="active mt-3 messegeRegisterButton"
                                        >Register Now!</b-button
                                    >
                                </div>
                            </b-card-body>
                        </b-card>
                    </b-card-group>
                </b-col>
            </b-row>
            <WitModal v-model="showRegisteredModal" title="Congratulations!" variant="primary" size="md">
                <div>
                    <h3>Your account has been created</h3>
                    What is left is for You to confirm Your email adress. We've send You all the instructions already!
                    😁
                </div>
                <b-button class="mt-2" variant="warning" block @click="showRegisteredModal = false"> Close</b-button>
            </WitModal>
            <WitModal v-model="showConfirmedModal" title="Congratulations!" variant="primary" size="md">
                <div>
                    <h3>Your email adress has been confirmed</h3>
                    Go ahead and log in! 😁
                </div>
                <b-button class="mt-2" variant="warning" block @click="showConfirmedModal = false"> Close</b-button>
            </WitModal>
            <Loading :loading="$store.state.loading.processing" :text="$store.state.loading.text"></Loading>
        </div>
    </div>
</template>

<script>
import {validationMixin} from 'vuelidate'

import {required, email} from 'vuelidate/lib/validators'

import Feedback from '@/components/Feedback'
import Loading from '@/components/loading.vue'
import WitModal from '@/components/Modals/WitModal.vue'

export default {
    data() {
        return {
            loginForm: {
                email: '',
                password: '',
            },
            loginError: {
                state: true,
                message: '',
            },
            showRegisteredModal: false,
            showConfirmedModal: false,
        }
    },
    mixins: [validationMixin],
    validations: {
        loginForm: {
            email: {
                required,
                email,
            },
            password: {
                required,
            },
        },
    },
    components: {
        Feedback,
        Loading,
        WitModal,
    },
    computed: {
        strategies: () => [],
        redirect() {
            return this.$route.query.redirect && decodeURIComponent(this.$route.query.redirect)
        },
        isCallback() {
            return Boolean(this.$route.query.callback)
        },
    },
    mounted() {
        if (this.$route.query.registered) {
            this.showRegisteredModal = true
        }
        if (this.$route.query.confirmed) {
            this.showConfirmedModal = true
        }
    },
    methods: {
        async login() {
            this.$store.commit('loading/PROCESSING', `Logging in...`)
            const login = await this.$auth
                .login({
                    data: {
                        email: this.loginForm.email,
                        password: this.loginForm.password,
                    },
                    success() {
                        this.$store.state.project.active = null
                        this.$store.commit('loading/PROCESSED')
                    },
                    fetchUser: true,
                })
                .catch(e => {
                    this.$store.commit('loading/PROCESSED')
                    this.loginError.state = false
                    this.loginError.message = e.response.data ? e.response.data : 'Could not log in'
                })
        },
        validateRef(ref) {
            const keys = ref.split('.')
            const validateField = keys.reduce((a, c) => {
                return a[c]
            }, this.$v)

            return validateField.$dirty ? !validateField.$invalid : null
        },
    },
}
</script>
